<template>
  <BaseModal
    name="pixel-fb"
    size="lg"
    title="Configuração do Pixel"
    @shown="openModal"
    @hidden="reset"
  >
    <div class="d-flex justify-content-center" v-if="loading">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <section class="container-pixel" v-else>
      <b-form novalidate v-show="step == 1">
        <img :src="iconeType" class="mb-4" />
        <b-form-group label="ID Pixel" label-for="pixel_id">
          <b-form-input
            id="pixel_id"
            name="pixel_id"
            type="text"
            autocomplete="off"
            v-model="pixel.pixel_id"
            :placeholder="cPlaceholderPixel"
            v-validate="'required'"
          ></b-form-input>
          <b-form-invalid-feedback :state="!errors.has('pixel_id')">
            Por favor, insira o ID Pixel.
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group
          v-if="type_pixel === 'GOOGLEADWORDS'"
          label="Label de Conversão (Opcional)"
          label-for="label_conversion"
          class="mt-4"
        >
          <b-form-input
            id="label_conversion"
            name="label_conversion"
            type="text"
            placeholder="Label de Conversão"
            autocomplete="off"
            v-model="pixel.label"
          ></b-form-input>
        </b-form-group>

        <b-form-group
          class="mt-4"
          id="events_pixel"
          label="Quais eventos você deseja receber?"
          label-for="events_pixel"
          data-anima="top"
          v-show="pixel.pixel_id"
        >
          <b-form-checkbox
            class="mt-3"
            name="events_pixel"
            v-model="pixel.view"
            size="lg"
            switch
          >
            <p class="info-checkbox">
              Visitas em Checkout
              <span class="descricao-checkbox"
                >Visitas na página de pagamento do produto.
              </span>
            </p>
          </b-form-checkbox>

          <b-form-checkbox
            class="mt-3"
            name="events_pixel"
            v-model="pixel.conversion"
            size="lg"
            switch
          >
            <p class="info-checkbox">
              Conversão de vendas
              <span class="descricao-checkbox"
                >Quantos chegaram até a 'página de obrigado’ do produto
              </span>
            </p>
          </b-form-checkbox>
        </b-form-group>

        <div v-if="pixel.pixel_id && pixel.conversion">
          <span
            data-anima="top"
            class="collapse-item collapse-arrow"
            v-b-toggle.collapse-pixel
            @click="collapse = !collapse"
            :class="{ ativo: collapse }"
          >
            Configurações avançadas
            <img src="@/assets/img/icons/arrow-fill.svg" alt="" />
          </span>

          <b-collapse id="collapse-pixel" data-anima="top" class="mt-3">
            <b-form-group
              class="mb-3"
              label="Receber confirmação de venda de qual meio de pagamento?"
              v-slot="{ ariaDescribedby }"
            >
              <b-form-radio-group
                class="mt-1"
                id="radio-group-1"
                v-model="pixel.confirmed_only"
                :options="options_pagamento"
                :aria-describedby="ariaDescribedby"
                name="radio-options"
                stacked
              ></b-form-radio-group>
            </b-form-group>

            <div>
              <b-form-checkbox
                class="mt-3"
                name="events_pixel"
                v-model="pixel.web"
                size="lg"
                switch
              >
                <p class="info-checkbox">
                  Navegador
                  <span class="descricao-checkbox"
                    >Dados serão enviados direto do navegador do usuário
                  </span>
                </p>
              </b-form-checkbox>

              <b-form-checkbox
                v-show="type_pixel == 'FACEBOOK'"
                class="mt-3"
                name="events_pixel"
                v-model="pixel.api"
                size="lg"
                switch
              >
                <p class="info-checkbox">
                  API de conversão
                  <span class="descricao-checkbox"
                    >Dados serão enviados para a API de conversão
                  </span>
                </p>
              </b-form-checkbox>

              <b-form-checkbox
                v-show="type_pixel == 'FACEBOOK'"
                class="mt-3"
                name="events_pixel"
                v-model="pixel.amount"
                size="lg"
                switch
              >
                <p class="info-checkbox">
                  Quer receber confirmações de venda com qual tipo de valor?
                  <span class="descricao-checkbox">Valor real da venda </span>
                </p>
              </b-form-checkbox>

              <b-form-group
                label="Token da API de conversão"
                label-for="token"
                v-if="pixel.api"
                data-anima="top"
                class="mt-3"
              >
                <b-form-input
                  id="token"
                  name="token"
                  type="text"
                  autocomplete="off"
                  v-model="pixel.token"
                  placeholder="Token da API de conversão"
                  v-validate="'required'"
                ></b-form-input>
                <b-form-invalid-feedback :state="!errors.has('token')">
                  Por favor, insira o Token da API de conversão.
                </b-form-invalid-feedback>
              </b-form-group>
            </div>
          </b-collapse>
        </div>
      </b-form>
      <b-form v-if="step == 2">
        <div data-anima="bottom">
          <b-form-group
            label="Deseja cadastrar seu domínio para veicular anúncios otimizados para eventos de conversão que ocorrem no seu site?"
            v-slot="{ ariaDescribedby }"
          >
            <p class="mini-info">
              Com a atualização do {{ type_pixel }}, para as novas políticas do
              iOS 14, só é possível veicular anúncios otimizados para eventos de
              conversão com <span>domínios verificados e próprios.</span>
            </p>
            <b-form-radio-group
              class="mt-3 mr-3"
              id="radio-group-2"
              v-model="has_domain"
              :options="options_domain"
              :aria-describedby="ariaDescribedby"
              name="radio-options"
            ></b-form-radio-group>
          </b-form-group>
        </div>

        <div v-if="has_domain == 'true'" class="mt-3" data-anima="top">
          <b-form-group
            label="Siga os passos abaixo para configuração do seu domínio, é preciso realizar etapas externas da plataforma da Voomp."
          >
            <ul class="steps">
              <li>
                <span>01.</span>
                <div>
                  <p>
                    Informe o domínio que você utiliza no
                    <b>Gerenciador de Negócios do {{ type_pixel }}.</b>
                  </p>
                  <span class="mini-info"
                    >O domínio precisa estar validado no gerenciador de
                    negócios</span
                  >
                  <div class="mt-2">
                    <b-form-input
                      id="domain"
                      name="domain"
                      type="text"
                      autocomplete="off"
                      v-model="pixel.domain.domain"
                      placeholder="Ex: seudominio.com.br"
                      v-validate="'required'"
                    ></b-form-input>
                    <b-form-invalid-feedback :state="!errors.has('domain')">
                      Por favor, insira um domínio válido
                    </b-form-invalid-feedback>
                  </div>
                </div>
              </li>
              <li>
                <span>02.</span>
                <div>
                  <p>Configurar o CNAME no seu provedor de domínio.</p>
                  <span class="mini-info"
                    >Para que o evento chegue no {{ type_pixel }} debaixo do seu
                    domínio, é preciso que você configure o CNAME no seu
                    provedor de domínio, para isso siga os passos abaixo.</span
                  >
                  <ul class="instrucoes">
                    <li>
                      <p>
                        a. No seu provedor de domínio vá em configuração de DNS.
                      </p>
                    </li>
                    <li>
                      <p>
                        b. Configure o CNAME
                        <b v-if="pixel && pixel.domain && pixel.domain.domain"
                          >voompcreators.{{ pixel.domain.domain }}</b
                        >
                        <b v-else>voompcreators.meudominio.com.br</b> apontando
                        para <b>{{ pixel_url }}</b>
                      </p>
                    </li>
                    <li><p>c. Salve o DNS.</p></li>
                    <li>
                      <p>d. Agora a verificação do CNAME e do Certificado.</p>
                      <span class="mini-info"
                        >De 1 em 1 hora nosso robô executa uma varredura e
                        verifica o CNAME e Certificado</span
                      >
                      <div class="status" :class="{ ativada: pixel.dns }">
                        CNAME
                        {{
                          pixel.dns ? "verificado" : "aguardando verificação"
                        }}
                      </div>
                      <div class="status" :class="{ ativada: pixel.ssl }">
                        Certificado
                        {{
                          pixel.ssl ? "verificado" : "aguardando verificação"
                        }}
                      </div>
                    </li>
                    <li>
                      <p>
                        e. Agora habilite a otimização do seu pixel do
                        {{ type_pixel }}.
                      </p>
                      <span class="mini-info"
                        >Você deverá ativar a otimização do
                        {{ type_pixel }} apenas depois da validação do CNAME e
                        ter o certificado gerado.</span
                      >
                      <b-form-group
                        class="mt-4 mb-3"
                        id="optimization_pixel"
                        label=""
                        label-for="optimization_pixel"
                        data-anima="top"
                      >
                        <b-form-checkbox
                          class="mt-3"
                          name="optimization_pixel"
                          v-model="pixel.optimization"
                          size="lg"
                          switch
                          :disabled="!pixel.dns && !pixel.ssl"
                        >
                          <p class="info-checkbox">Otimização desativada</p>
                        </b-form-checkbox>
                      </b-form-group>
                    </li>
                  </ul>
                  <span class="mini-info"
                    >Em caso de dúvidas nesse processo, consulte seu provedor de
                    domínio.
                  </span>
                </div>
              </li>
            </ul>
          </b-form-group>
        </div>
      </b-form>
    </section>

    <template v-slot:footer>
      <BaseButton
        :disabled="loading"
        variant="secondary_outline"
        class="mr-3"
        @click="back"
      >
        {{ step == 1 ? "Cancelar" : "Voltar" }}
      </BaseButton>
      <div v-if="pixel.pixel_id" data-anima="right">
        <BaseButton variant="info3" @click="next">
          {{ step == 1 ? "Continuar" : "Concluir" }}</BaseButton
        >
      </div>
    </template>
  </BaseModal>
</template>
<script>
import ConversionPixelService from "@/services/resources/ConversionPixelService";
const serviceConversionPixel = ConversionPixelService.build();

export default {
  props: {
    product_id: {
      type: Number,
      default: -1,
    },
    type_pixel: {
      type: String,
      default: "FACEBOOK",
    },
    pixel_edit: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      loading: false,
      collapse: false,
      step: 1,
      placeholderPixel: {
        FACEBOOK: "Ex: 1234567890",
        GOOGLEADWORDS: "Ex: AW-0000000000",
        GOOGLETAGMANAGER: "Ex: GTM-XXXXXXX",
        GOOGLEANALYTICS: "Ex: UA-000000-00 ou G-XXXXXXXX",
        TIKTOK: "Ex: 1234567890",
      },
      pixel: {
        pixel_id: "",
        product_id: -1,
        type: "",
        confirmed_only: 0,
        web: true,
        api: false,
        amount: false,
        token: "",
        domain: {
          domain: "",
        },
        view: true,
        conversion: true,
      },
      pixel_url: process.env.VUE_PIXEL_URL,
      pixel_request: {},
      options_pagamento: [
        { text: "Todos os meios de pagamento", value: 0 },
        { text: "Somente confirmados", value: 1 },
      ],
      has_domain: null,
      options_domain: [
        { text: "Sim", value: "true" },
        { text: "Não", value: "false" },
      ],
    };
  },

  computed: {
    iconeType() {
      if (this.type_pixel) {
        return require(`@/assets/img/${this.type_pixel.toLowerCase()}_icone.png`);
      } else return false;
    },
    cPlaceholderPixel() {
      return this.placeholderPixel[this.type_pixel] || "";
    },
  },
  methods: {
    back() {
      if (this.step == 2) {
        this.step = 1;
      } else {
        this.$bvModal.hide("pixel-fb");
      }
    },
    next() {
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          if (this.step == 1) {
            this.step = 2;
          } else {
            this.formatObjectPixel();
          }
        }
      });
    },
    formatObjectPixel() {
      this.pixel_request = {
        pixel_id: this.pixel.pixel_id,
        product_id: this.product_id,
        type: this.pixel.type,
        web: this.pixel.web ? 1 : 0,
        api: this.pixel.api ? 1 : 0,
        confirmed_only: this.pixel.confirmed_only ? 1 : 0,
        token: this.pixel.token,
        domain: this.pixel.domain.domain,
        view: this.pixel.view ? 1 : 0,
        conversion: this.pixel.conversion ? 1 : 0,
        optimization: this.pixel.optimization ? 1 : 0,
      };

      if (this.type_pixel === "GOOGLEADWORDS" && this.pixel.label) {
        this.pixel_request.label = this.pixel.label;
      }

      if (this.type_pixel != "FACEBOOK") {
        this.pixel_request.api = 0;
        this.pixel_request.token = "";
      }

      if (this.type_pixel == "FACEBOOK") {
        this.pixel_request.amount = this.pixel.amount ? 1 : 0;
      }

      this.onSubmit();
    },
    atualizaPixel() {
      this.loading = true;
      let data = {
        id: this.pixel.id,
        ...this.pixel_request,
      };
      serviceConversionPixel
        .update(data)
        .then(() => {
          this.$bvToast.toast("Pixel atualizado com sucesso", {
            title: "Pixel",
            variant: "success",
            autoHideDelay: 5000,
            appendToast: true,
          });
          this.$emit("close", true);
          this.$bvModal.hide("pixel-fb");
          this.reset();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmit() {
      if (this.pixel_edit.edit) {
        this.atualizaPixel();
      } else {
        this.loading = true;
        serviceConversionPixel
          .create(this.pixel_request)
          .then(() => {
            this.$bvToast.toast("Pixel adicionado com sucesso", {
              title: "Pixel",
              variant: "success",
              autoHideDelay: 5000,
              appendToast: true,
            });
            this.$emit("close", true);
            this.$bvModal.hide("pixel-fb");
            this.reset();
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    openModal() {
      this.loading = true;

      if (this.pixel_edit.edit) {
        console.log(this.pixel_edit);
        this.pixel = {
          id: this.pixel_edit.item.id,
          pixel_id: this.pixel_edit.item.pixel_id,
          product_id: this.product_id,
          type: this.pixel_edit.item.type,
          label: this.pixel_edit.item.label,
          dns: this.pixel_edit.item.dns,
          ssl: this.pixel_edit.item.ssl,
          confirmed_only: this.pixel_edit.item.confirmed_only ? 1 : 0,
          web: this.pixel_edit.item.web ? true : false,
          api: this.pixel_edit.item.api ? true : false,
          amount: this.pixel_edit.item.amount ? true : false,
          token: this.pixel_edit.item.token,
          domain: this.pixel_edit.item.domain
            ? this.pixel_edit.item.domain
            : [],
          view: this.pixel_edit.item.view ? true : false,
          conversion: this.pixel_edit.item.conversion ? true : false,
          optimization: this.pixel_edit.item.optimization ? true : false,
        };

        if (this.pixel.domain && this.pixel.domain.domain) {
          this.has_domain = "true";
        } else {
          this.has_domain = "false";
        }
      } else {
        this.reset();
      }
      this.loading = false;
    },
    reset() {
      this.pixel = {
        pixel_id: "",
        product_id: -1,
        type: this.type_pixel,
        confirmed_only: 0,
        web: true,
        api: false,
        token: "",
        domain: {
          domain: "",
        },
        view: true,
        conversion: true,
      };

      this.has_domain = null;
      this.collapse = false;
      this.step = 1;
      this.$emit("close", false);
    },
  },
};
</script>

<style lang="scss" scoped>
#pixel_id {
  width: 300px;
}
#events_pixel {
  max-width: 480px;
}
.info-checkbox {
  cursor: pointer;
}
.info-checkbox span {
  font-size: 12px;
}
.descricao-checkbox {
  margin-left: 0 !important;
}
.collapse-item {
  margin-top: 30px;
  font-size: 13px;
  color: #2a63ab;
  padding: 15px 20px;
  border: 1px solid #ededf0;
  border-radius: 5px;
}
// collapse
.collapse-arrow {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
}
.collapse-arrow.ativo {
  margin-bottom: 15px;
  color: #333;
  border-bottom-color: transparent;
}
.collapse-arrow.ativo img {
  transition: 0.3s;
  transform: rotate(180deg);
}
.mini-info {
  color: #81858e !important;
  font-size: 12px !important;
  font-weight: normal !important;
}
.mini-info span {
  font-weight: 600;
  color: #81858e;
}
.steps {
  margin: 10px 0;
  /* max-width: 80%; */
}
.steps li {
  display: flex;
  align-items: flex-start;
  gap: 15px;
}
.steps li + li {
  margin-top: 15px;
}
.steps li span {
  font-weight: 600;
  font-size: 14px;
  color: #2a63ab;
}
.steps p {
  font-size: 14px;
}

// instrucoes
.instrucoes {
  margin: 10px 0;
}
.instrucoes li {
  display: block;
  background: #f7f7f7;
  padding: 15px;
  border-radius: 5px;
  max-width: 79%;
}
@media screen and (max-width: 768px) {
  .instrucoes li {
    max-width: 100%;
  }
}
.instrucoes li p {
  font-size: 13px;
  line-height: 1.5;
}
.instrucoes li + li {
  margin-top: 15px;
}
.status {
  margin-top: 10px;
  display: inline-block;
  background: #eee;
  color: #000;
  padding: 5px 10px;
  font-size: 12px;
  border-radius: 4px;
}

.status.ativada {
  background: #00236320;
  color: #002363;
}
.status + .status {
  margin-left: 15px;
}
@media screen and (max-width: 768px) {
  .status {
    display: block;
  }
  .status + .status {
    margin: 0;
    margin-top: 10px;
  }
}
.info-checkbox {
  display: inline;
}
#token {
  max-width: 500px;
}
</style>
